import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { t } from 'i18next';
import { UilUsersAlt } from '@iconscout/react-unicons';
import SearchBox from 'components/common/SearchBox';
import { DataNotFound } from 'base/DataNotFound/DataNotFound';
import { AVATAR_COLORS } from 'utils/staticData';
import './ViewUserModal.scss';

export interface ViewUserModalUser {
  first_name: string;
  last_name: string;
  email?: string;
}

interface ViewUserModalProps {
  show: boolean;
  setShow: (value: boolean) => void;
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  users: ViewUserModalUser[];
}

const getInitials = (firstName: string, lastName: string) => {
  const f = firstName?.charAt(0)?.toUpperCase() ?? '';
  const l = lastName?.charAt(0)?.toUpperCase() ?? '';
  return `${f}${l}`;
};

const getAvatarColor = (index: number) =>
  AVATAR_COLORS[index % AVATAR_COLORS.length];

const ViewUserModal = (props: ViewUserModalProps) => {
  const [searchText, setSearchText] = useState('');

  const filteredUsers = props.users.filter(user => {
    const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
    return fullName.includes(searchText.toLowerCase());
  });

  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      size="lg"
      className="view-admin-level-modal"
    >
      <Modal.Header closeButton>
        <div className="level-header-content">
          <div className="level-avatar">
            {props.icon ?? <UilUsersAlt size={22} color="#dc3545" />}
          </div>
          <div>
            <p className="level-title">{props.title}</p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="search-bar-sticky d-flex justify-content-between align-items-center">
          <div className="users-summary">
            <UilUsersAlt size={22} color="currentColor" />
            {filteredUsers.length} {t('general.text_15')}
          </div>
          <SearchBox
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
          />
        </div>
        {filteredUsers.length > 0 ? (
          <div className="users-grid">
            {filteredUsers.map((user, index) => {
              const color = getAvatarColor(index);
              return (
                <div className="user-card" key={`view-user-modal-${index}`}>
                  <div
                    className="user-initials"
                    style={{ backgroundColor: color.bg, color: color.text }}
                  >
                    {getInitials(user.first_name, user.last_name)}
                  </div>
                  <div className="user-info">
                    <span className="user-name">
                      {user.first_name} {user.last_name}
                    </span>
                    {user.email && (
                      <span className="user-email">{user.email}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <DataNotFound />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewUserModal;
